import React from "react";
import { LayoutContentWrapper } from "./layoutWrapper.style";
import withLoader from "../LoadingContainer"

const layoutContentWrapper = props => (
  <LayoutContentWrapper
    className={
      props.className != null
        ? `${props.className} isoLayoutContentWrapper`
        : "isoLayoutContentWrapper"
    }
    {...props}
  >
    {props.children}
  </LayoutContentWrapper>
);

export default withLoader(layoutContentWrapper);



// WEBPACK FOOTER //
// ./src/components/ui-ant/utility/layoutWrapper.js